import { IconProps } from "../../utils/global-types/global-types";

const SvgIcon = ({ className, ...rest }: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    className={className ? className : "w-5 h-5"}
    {...rest}
  >
    <path
      fill="currentColor"
      d="M4.73 5.018a3.518 3.518 0 1 1 7.036 0 3.518 3.518 0 0 1-7.036 0M2.45 13.822A4.27 4.27 0 0 1 6.72 9.55h3.054c.808 0 1.563.224 2.208.614.195.118.213.386.052.547L9.24 13.505a2.63 2.63 0 0 0-.766 1.728l-.014.28a.375.375 0 0 1-.374.357H4.498a2.05 2.05 0 0 1-2.048-2.048M12.697 12.17a.375.375 0 0 0-.53 0l-2.13 2.13a1.5 1.5 0 0 0-.438.988l-.04.821c-.011.214.16.393.374.393h.702a1.5 1.5 0 0 0 1.04-.42l2.238-2.155a.375.375 0 0 0 .005-.535zM14.761 12.644a.325.325 0 0 0 .46 0c.44-.44.44-1.152 0-1.591l-.173-.173a1.125 1.125 0 0 0-1.59 0 .325.325 0 0 0 0 .46z"
    ></path>
  </svg>
);

export default SvgIcon;
